module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24401/sass/messagesWidgetShell.sass"